import { MultigameParams } from "../../MultigameParams";
import { SlotGameInitData } from "../../SlotGameInitData";
import { RainbowTreasure_ResponsivePIXIApp } from "../RainbowTreasure/game_ResponsivePIXIApp";

export class RainbowTreasureLink_ResponsivePIXIApp extends RainbowTreasure_ResponsivePIXIApp {

    constructor(multigameParams: MultigameParams, initData: SlotGameInitData) {
        super(multigameParams, initData, "RainbowTreasureLink");
    }

}